import { createPartnerConfig } from '../base/PartnerConfigFactory';

import Parameters from './Parameters';
import validate from './validate';

export const name = 'Default';

const config = createPartnerConfig({
    ParametersComponent: Parameters,
    customAlgorithms: [
        { label: 'PPA Algorithm', value: 'ppa_sunwise' },
        { label: 'Shared savings', value: 'shared_savings' },
    ],
    name,
    validationConfig: { schema: validate },
});

export default { ...config, name };
